import React from 'react';
import { Button } from '../components/ui/button';
import { Phone, Building2, Factory, Waves, Zap, Construction, Wheat } from 'lucide-react';
import './Clientes.css';

const Clientes = () => {
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=\u00a1Hola!%20Quiero%20conocer%20m\u00e1s%20sobre%20sus%20servicios`;

  const sectores = [
    {
      icon: <Waves size={28} />,
      nombre: 'Agua y saneamiento',
      descripcion: 'Empresas de distribución de agua potable, tratamiento de efluentes y servicios sanitarios.'
    },
    {
      icon: <Factory size={28} />,
      nombre: 'Industria química y petroquímica',
      descripcion: 'Plantas de producción, refinerías y empresas del sector energético.'
    },
    {
      icon: <Wheat size={28} />,
      nombre: 'Agroindustria',
      descripcion: 'Plantas de procesamiento de granos, aceites vegetales y producción de alimento balanceado.'
    },
    {
      icon: <Zap size={28} />,
      nombre: 'Energía',
      descripcion: 'Centrales térmicas, hidroeléctricas y proyectos de infraestructura energética.'
    },
    {
      icon: <Building2 size={28} />,
      nombre: 'Construcción',
      descripcion: 'Desarrollos inmobiliarios, edificios comerciales e institucionales.'
    },
    {
      icon: <Construction size={28} />,
      nombre: 'Minería',
      descripcion: 'Proyectos mineros y de extracción de recursos naturales.'
    }
  ];

  const clientes = [
    { nombre: 'ACA', logo: '/assets/logos/clientes/ACA-LOGO.jpg' },
    { nombre: 'ACHA', logo: '/assets/logos/clientes/ACHA-LOGO.png' },
    { nombre: 'ACINDAR', logo: '/assets/logos/clientes/ACINDAR-LOGO.png' },
    { nombre: 'ADALMI', logo: '/assets/logos/clientes/ADALMI-LOGO.jpeg' },
    { nombre: 'ADM', logo: '/assets/logos/clientes/ADM-LOGO.webp' },
    { nombre: 'AES', logo: '/assets/logos/clientes/AES-LOGO.webp' },
    { nombre: 'AFA', logo: '/assets/logos/clientes/AFA-LOGO.jpeg' },
    { nombre: 'AGD', logo: '/assets/logos/clientes/AGD-LOGO.jpeg' },
    { nombre: 'AGROSERVICIOS HUMBOLDT', logo: '/assets/logos/clientes/AGROSERVICIOS-HUMBOLDT-LOGO.png' },
    { nombre: 'AGUAS SANTAFESINAS', logo: '/assets/logos/clientes/AGUAS-SANTAFESINAS-LOGO.jpg' },
    { nombre: 'AIR LIQUIDE', logo: '/assets/logos/clientes/AIR-LIQUIDE-LOGO.png' },
    { nombre: 'ALBANESI', logo: '/assets/logos/clientes/ALBANESI-LOGO.jpg' },
    { nombre: 'ALGODONERA AVELLANEDA', logo: '/assets/logos/clientes/ALGODONERA-AVELLANEDA-LOGO.jpeg' },
    { nombre: 'AMBEV', logo: '/assets/logos/clientes/AMBEV-LOGO.png' },
    { nombre: 'AR ZINC', logo: '/assets/logos/clientes/AR-ZINC-LOGO.jpg' },
    { nombre: 'ARAUCO', logo: '/assets/logos/clientes/ARAUCO-LOGO.png' },
    { nombre: 'ASTRAZENECA', logo: '/assets/logos/clientes/ASTRAZENECA-LOGO.png' },
    { nombre: 'AVIGAN', logo: '/assets/logos/clientes/AVIGAN-LOGO.jpg' },
    { nombre: 'BANCO NACION', logo: '/assets/logos/clientes/BANCO-NACION-LOGO.png' },
    { nombre: 'BIO4', logo: '/assets/logos/clientes/BIO4-LOGO.jpeg' },
    { nombre: 'BOLSA COMERCIO', logo: '/assets/logos/clientes/BOLSA-COMERCIO-LOGO.jpeg' },
    { nombre: 'BOORTMALT', logo: '/assets/logos/clientes/BOORTMALT-LOGO.png' },
    { nombre: 'BOSCARINO CONSTRUCCIONES', logo: '/assets/logos/clientes/BOSCARINO-CONSTRUCCIONES-LOGO.png' },
    { nombre: 'BRF MARFRIG', logo: '/assets/logos/clientes/BRF-MARFRIG-LOGO.jpeg' },
    { nombre: 'BUNGE', logo: '/assets/logos/clientes/BUNGE-LOGO.png' },
    { nombre: 'BUYANOR', logo: '/assets/logos/clientes/BUYANOR-LOGO.jpg' },
    { nombre: 'BUYATTI', logo: '/assets/logos/clientes/BUYATTI-LOGO.png' },
    { nombre: 'CARGILL', logo: '/assets/logos/clientes/CARGILL-LOGO.png' },
    { nombre: 'CARREFOUR', logo: '/assets/logos/clientes/CARREFOUR-LOGO.webp' },
    { nombre: 'CARTONERA PUERTO', logo: '/assets/logos/clientes/CARTONERA-PUERTO-LOGO.jpeg' },
    { nombre: 'CCU', logo: '/assets/logos/clientes/CCU-LOGO.png' },
    { nombre: 'CENTRAL VUELTA OBLIGADO', logo: '/assets/logos/clientes/CENTRAL-VUELTA-OBLIGADO-LOGO.png' },
    { nombre: 'CENTRALES COSTA ATLANTICA', logo: '/assets/logos/clientes/CENTRALES-COSTA-ATLANTICA-LOGO.jpeg' },
    { nombre: 'CERAMICA ALBERDI', logo: '/assets/logos/clientes/CERAMICA-ALBERDI-LOGO.jpeg' },
    { nombre: 'COCYAR', logo: '/assets/logos/clientes/COCYAR-LOGO.jpeg' },
    { nombre: 'COEMYC', logo: '/assets/logos/clientes/COEMYC-LOGO.jpeg' },
    { nombre: 'COFCO', logo: '/assets/logos/clientes/COFCO-LOGO.jpeg' },
    { nombre: 'COMACSA', logo: '/assets/logos/clientes/COMACSA-LOGO.jpeg' },
    { nombre: 'CONSTRUCCIONES CIVILES INDUSTRIALES', logo: '/assets/logos/clientes/CONSTRUCCIONES-CIVILES-INSDUSTRIALES-LOGO.jpeg' },
    { nombre: 'CORTEVA', logo: '/assets/logos/clientes/CORTEVA-LOGO.png' },
    { nombre: 'CPM', logo: '/assets/logos/clientes/CPM-LOGO.webp' },
    { nombre: 'CSB', logo: '/assets/logos/clientes/CSB-LOGO.png' },
    { nombre: 'DANA', logo: '/assets/logos/clientes/DANA-LOGO.png' },
    { nombre: 'DETEXA', logo: '/assets/logos/clientes/DETEXA-LOGO.png' },
    { nombre: 'DOW QUIMICA', logo: '/assets/logos/clientes/DOW-QUIMICA-LOGO.jpeg' },
    { nombre: 'EDECA', logo: '/assets/logos/clientes/EDECA-LOGO.jpeg' },
    { nombre: 'ENTRE RIOS CRUSHING', logo: '/assets/logos/clientes/ENTRE-RIOS-CRUSHING-LOGO.png' },
    { nombre: 'EXPLORA', logo: '/assets/logos/clientes/EXPLORA-LOGO.png' },
    { nombre: 'FEPASA', logo: '/assets/logos/clientes/FEPASA-LOGO.jpeg' },
    { nombre: 'FIPLASTO', logo: '/assets/logos/clientes/FIPLASTO-LOGO.png' },
    { nombre: 'FRIAR', logo: '/assets/logos/clientes/FRIAR-LOGO.jpeg' },
    { nombre: 'GENERAL MOTORS', logo: '/assets/logos/clientes/GENERAL-MOTORS-LOGO.jpeg' },
    { nombre: 'GENTE DE LA PAMPA', logo: '/assets/logos/clientes/GENTE-DE-LA-PAMPA-LOGO.jpeg' },
    { nombre: 'GERDAU', logo: '/assets/logos/clientes/GERDAU-LOGO.png' },
    { nombre: 'GIER', logo: '/assets/logos/clientes/GIER-LOGO.png' },
    { nombre: 'GLENCORE', logo: '/assets/logos/clientes/GLENCORE-LOGO.png' },
    { nombre: 'HIDRAULICA ENTRE RIOS', logo: '/assets/logos/clientes/HIDRAULICA-ENTRE-RIOS-LOGO.svg' },
    { nombre: 'HIDROCONSTRUCCIONES', logo: '/assets/logos/clientes/HIDROCONSTRUCCIONES-LOGO.png' },
    { nombre: 'IDM INGENIERIA', logo: '/assets/logos/clientes/IDM-INGENIERIA-CONSTRUCCION-LOGO.png' },
    { nombre: 'INAGRO', logo: '/assets/logos/clientes/INAGRO-LOGO.png' },
    { nombre: 'INNOVA', logo: '/assets/logos/clientes/INNOVA-LOGO.jpeg' },
    { nombre: 'JSB', logo: '/assets/logos/clientes/JSB-LOGO.jpeg' },
    { nombre: 'KECLON', logo: '/assets/logos/clientes/KECLON-LOGO.jpg' },
    { nombre: 'LA NUEVA MANERA VIRGILIO', logo: '/assets/logos/clientes/LA-NUEVA-MANERA-VIRGILIO-LOGO.png' },
    { nombre: 'LA SIBILA', logo: '/assets/logos/clientes/LA-SIBILA-LOGO.jpeg' },
    { nombre: 'LA VIRGINIA', logo: '/assets/logos/clientes/LA-VIRGINIA-LOGO.jpg' },
    { nombre: 'LAS CAMELIAS', logo: '/assets/logos/clientes/LAS-CAMELIAS-LOGO.png' },
    { nombre: 'LDC', logo: '/assets/logos/clientes/LDC-LOGO.jpeg' },
    { nombre: 'MASA', logo: '/assets/logos/clientes/MASA-LOGO.png' },
    { nombre: 'MASTRODICASA CONSTRUCCIONES', logo: '/assets/logos/clientes/MASTRODICASA-CONSTRUCCIONES-LOGO.jpeg' },
    { nombre: 'MATTIEVICH', logo: '/assets/logos/clientes/MATTIEVICH-LOGO.jpeg' },
    { nombre: 'MERCADO CONCENTRACION FISHERTON', logo: '/assets/logos/clientes/MERCADO-CONCENTRACION-FISHERTON-LOGO.png' },
    { nombre: 'MILICIC', logo: '/assets/logos/clientes/MILICIC-LOGO.jpeg' },
    { nombre: 'MOLINOS AGRO', logo: '/assets/logos/clientes/MOLINOS-AGRO-LOGO.jpeg' },
    { nombre: 'MOLINOS RIO DE LA PLATA', logo: '/assets/logos/clientes/MOLINOS-RIO-DE-LA-PLATA-LOGO.jpeg' },
    { nombre: 'MONTHELADO', logo: '/assets/logos/clientes/MONTHELADO-LOGO.jpeg' },
    { nombre: 'MUNDO CONSTRUCCIONES', logo: '/assets/logos/clientes/MUNDO-CONSTRUCCIONES-LOGO.jpeg' },
    { nombre: 'MUNICIPALIDAD CRESPO', logo: '/assets/logos/clientes/MUNICIPALIDAD-CRESPO-LOGO.png' },
    { nombre: 'MUNICIPALIDAD DAIREAU', logo: '/assets/logos/clientes/MUNICIPALIDAD-DAIREAU-LOGO.png' },
    { nombre: 'MUNICIPALIDAD NECOCHEA', logo: '/assets/logos/clientes/MUNICIPALIDAD-NECOCHEA-LOGO.jpg' },
    { nombre: 'MUNICIPALIDAD PARANA', logo: '/assets/logos/clientes/MUNICIPALIDAD-PARANA.png' },
    { nombre: 'MUNICIPALIDAD ROSARIO', logo: '/assets/logos/clientes/MUNICIPALIDAD-ROSARIO-LOGO.jpg' },
    { nombre: 'MUNICIPALIDAD SANTO TOME', logo: '/assets/logos/clientes/MUNICIPALIDAD-SANTO-TOME-LOGO.png' },
    { nombre: 'NOURYON', logo: '/assets/logos/clientes/NOURYON-LOGO.jpg' },
    { nombre: 'OLEAGINOSA SAN LORENZO', logo: '/assets/logos/clientes/OLEAGINOSA-SAN-LORENZO-LOGO.jpg' },
    { nombre: 'OMEGA CONSTRUCCIONES', logo: '/assets/logos/clientes/OMEGA-CONSTRUCCIONES-LOGO.jpeg' },
    { nombre: 'OSVALDO METALURGICA', logo: '/assets/logos/clientes/OSVALDO-METALURGICA-LOGO.png' },
    { nombre: 'PALADINI', logo: '/assets/logos/clientes/PALADINI-LOGO.png' },
    { nombre: 'PAMPA ENERGIA', logo: '/assets/logos/clientes/PAMPA-ENERGIA-LOGO.png' },
    { nombre: 'PAPEL TECNICA', logo: '/assets/logos/clientes/PAPEL-TECNICA-LOGO.jpeg' },
    { nombre: 'PATAGONIA BIOENERGIA', logo: '/assets/logos/clientes/PATAGONIA-BIOENERGIA-LOGO.webp' },
    { nombre: 'PB LEINER', logo: '/assets/logos/clientes/PB-LEINER.jpeg' },
    { nombre: 'PEITEL', logo: '/assets/logos/clientes/PEITEL-LOGO.jpeg' },
    { nombre: 'PERFORACIONES BAIGORRIA', logo: '/assets/logos/clientes/PERFORACIONES-BAIGORRIA-LOGO.jpg' },
    { nombre: 'PETRO PACK', logo: '/assets/logos/clientes/PETRO-PACK-LOGO.jpeg' },
    { nombre: 'PETROBRAS', logo: '/assets/logos/clientes/PETROBRAS-LOGO.png' },
    { nombre: 'PETROQUIMICA RIO TERCERO', logo: '/assets/logos/clientes/PETROQUIMICA-RIO-TERCERO-LOGO.jpg' },
    { nombre: 'PROFERTIL', logo: '/assets/logos/clientes/PROFERTIL-LOGO.png' },
    { nombre: 'PROMAIZ', logo: '/assets/logos/clientes/PROMAIZ-LOGO.png' },
    { nombre: 'PROTOIL SRL', logo: '/assets/logos/clientes/PROTOIL-SRL.png' },
    { nombre: 'PUERTO QUEQUEN', logo: '/assets/logos/clientes/PUERTO-QUEQUEN-LOGO.png' },
    { nombre: 'PURINA', logo: '/assets/logos/clientes/PURINA-LOGO.webp' },
    { nombre: 'QH INGENIERIA', logo: '/assets/logos/clientes/QH-INGENIERIA-LOGO.webp' },
    { nombre: 'RAFAELA', logo: '/assets/logos/clientes/RAFAELA-LOGO.png' },
    { nombre: 'RENO PACK', logo: '/assets/logos/clientes/RENO-PACK-LOGO.jpeg' },
    { nombre: 'RENOVA', logo: '/assets/logos/clientes/RENOVA-LOGO.png' },
    { nombre: 'RICEDAL', logo: '/assets/logos/clientes/RICEDAL-LOGO.png' },
    { nombre: 'ROVIAL', logo: '/assets/logos/clientes/ROVIAL-LOGO.jpg' },
    { nombre: 'SADEPAN LATINOAMERICA', logo: '/assets/logos/clientes/SADEPAN-LATINOAMERICA-LOGO.png' },
    { nombre: 'SADESA', logo: '/assets/logos/clientes/SADESA-LOGO.png' },
    { nombre: 'SAJONIA', logo: '/assets/logos/clientes/SAJONIA-LOGO.svg' },
    { nombre: 'SANCHEZ SANCHEZ', logo: '/assets/logos/clientes/SANCHEZ-SANCHEZ-LOGO.png' },
    { nombre: 'SANCOR', logo: '/assets/logos/clientes/SANCOR-LOGO.png' },
    { nombre: 'SANIMAT', logo: '/assets/logos/clientes/SANIMAT-LOGO.jpeg' },
    { nombre: 'SANTA ISABEL', logo: '/assets/logos/clientes/SANTA-ISABEL-LOGO.webp' },
    { nombre: 'SAVENCIA', logo: '/assets/logos/clientes/SAVENCIA-LOGO.jpeg' },
    { nombre: 'SEMINO', logo: '/assets/logos/clientes/SEMINO-LOGO.jpg' },
    { nombre: 'SERVICIOS PORTUARIOS', logo: '/assets/logos/clientes/SERVICIOS-PORTUARIOS-LOGO.png' },
    { nombre: 'SIEMENS', logo: '/assets/logos/clientes/SIEMENS-LOGO.png' },
    { nombre: 'SIPAR GERDAU', logo: '/assets/logos/clientes/SIPAR-GERDAU-LOGO.jpg' },
    { nombre: 'SOL CONSTRUCCIONES', logo: '/assets/logos/clientes/SOL-CONSTRUCCIONES.jpeg' },
    { nombre: 'SYNTHON', logo: '/assets/logos/clientes/SYNTHON-LOGO.jpeg' },
    { nombre: 'TANONI', logo: '/assets/logos/clientes/TANONI-LOGO.jpg' },
    { nombre: 'TERMINAL 6', logo: '/assets/logos/clientes/TERMINAL-6-LOGO.png' },
    { nombre: 'TERMINAL BAHIA BLANCA', logo: '/assets/logos/clientes/TERMINAL-BAHIA-BLANCA-LOGO.png' },
    { nombre: 'TERMINAL FERTILIZANTES ARGENTINOS', logo: '/assets/logos/clientes/TERMINAL-FERTILIZANTES-ARGENTINOS-LOGO.png' },
    { nombre: 'TGS', logo: '/assets/logos/clientes/TGS-LOGO.jpeg' },
    { nombre: 'UNILEVER', logo: '/assets/logos/clientes/UNILEVER-LOGO.jpeg' },
    { nombre: 'UNIPAR INDUPA', logo: '/assets/logos/clientes/UNIPAR-INDUPA-LOGO.png' },
    { nombre: 'VALVULAS Y BOMBAS', logo: '/assets/logos/clientes/VALVULAS-Y-BOMBAS-LOGO.jpeg' },
    { nombre: 'VARTECO', logo: '/assets/logos/clientes/VARTECO-LOGO.png' },
    { nombre: 'VERONICA', logo: '/assets/logos/clientes/VERONICA-LOGO.jpeg' },
    { nombre: 'VICENTIN', logo: '/assets/logos/clientes/VICENTIN-LOGO.jpg' },
    { nombre: 'VITERRA', logo: '/assets/logos/clientes/VITERRA-LOGO.jpg' },
    { nombre: 'WERK', logo: '/assets/logos/clientes/WERK-LOGO.png' },
    { nombre: 'WINKELMANN', logo: '/assets/logos/clientes/WINKELMANN-LOGO.png' },
    { nombre: 'YPF', logo: '/assets/logos/clientes/YPF-LOGO.png' },
  ];

  const beneficios = [
    {
      titulo: 'Experiencia comprobada',
      descripcion: 'Más de 30 años acompañando el desarrollo industrial en Argentina.'
    },
    {
      titulo: 'Marcas líderes',
      descripcion: 'Representamos a KSB y TECNAL, fabricantes de reconocimiento mundial.'
    },
    {
      titulo: 'Soporte especializado',
      descripcion: 'Asesoramiento técnico en todas las etapas del proyecto.'
    },
    {
      titulo: 'Soluciones personalizadas',
      descripcion: 'Adaptamos cada propuesta a las necesidades específicas de cada cliente.'
    },
    {
      titulo: 'Compromiso con la calidad',
      descripcion: 'Equipos confiables que garantizan eficiencia y durabilidad.'
    },
    {
      titulo: 'Servicio post-venta',
      descripcion: 'Acompañamiento continuo para asegurar el óptimo funcionamiento de los equipos.'
    }
  ];

  return (
    <div className="clientes-container">
      {/* Hero Section */}
      <section className="clientes-hero">
        <div className="clientes-hero-content">
          <h1 className="clientes-hero-title">Nuestros Clientes</h1>
          <p className="clientes-hero-subtitle">
            Cada una de estas empresas representa una relación construida sobre confianza, compromiso y resultados.
          </p>
        </div>
      </section>

      {/* Logos de Clientes */}
      <section className="clientes-logos-section">
        <div className="container">
          <div className="clientes-logos-grid">
            {clientes.map((cliente, idx) => (
              <div key={idx} className="cliente-logo-card">
                <img src={cliente.logo} alt={cliente.nombre} loading="lazy" className="cliente-logo" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sectores */}
      <section className="clientes-sectores-section">
        <div className="container">
          <h2 className="section-title">Sectores que Atendemos</h2>
          <p className="section-description">
            Nuestra experiencia abarca una amplia gama de industrias, cada una con necesidades específicas 
            que atendemos con soluciones personalizadas.
          </p>
          
          <div className="clientes-sectores-grid">
            {sectores.map((sector, idx) => (
              <div key={idx} className="clientes-sector-card">
                <div className="clientes-sector-icon">{sector.icon}</div>
                <h3 className="clientes-sector-nombre">{sector.nombre}</h3>
                <p className="clientes-sector-descripcion">{sector.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Por qué nos eligen */}
      <section className="clientes-beneficios-section">
        <div className="container">
          <h2 className="section-title">¿Por qué nos eligen?</h2>
          <div className="clientes-beneficios-grid">
            {beneficios.map((beneficio, idx) => (
              <div key={idx} className="clientes-beneficio-item">
                <h3>{beneficio.titulo}</h3>
                <p>{beneficio.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="clientes-cta-section">
        <div className="container">
          <h2 className="clientes-cta-title">Representamos tecnología que potencia la eficiencia y confiabilidad de tus procesos</h2>
          <Button 
            size="lg" 
            className="clientes-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
          >
            <Phone className="mr-2" size={20} />
            Contactanos
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Clientes;
